<template>
  <v-btn color="primary"
         small
         outline
         @click="goTo('newManualShipment', { id: shipment.id })"
         v-if="canGenerateLabel"
         :disabled="$auth.isCust()"
         >
         {{ this.buttonText || this.$t('createLabel') }}
  </v-btn>
</template>

<script>
import Shipment from '@/client/shipment'

export default {
  name: 'ShipmentGenerateBtnComp',

  props: {
    shipment: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      buttonText: ''
    }
  },

  components: {
  },

  computed: {
    canGenerateLabel () {
      if (this.shipment.source === 'manual' && !this.$auth.isCust() && this.shipment.status === 'success') {
        if (this.shipment.generated_label) this.buttonText = this.$t('editLabel')
        return true
      }

      return false
    }
  },

  methods: {
  },

  watch: {
  },

  async mounted () {
    // this.buttonText = this.$t('createLabel')
  }
}
</script>